import { useMatch } from 'react-router-dom';

/** A matched deal route: which deal, and the sub-page suffix within it. */
export type DealRouteMatch = {
  implementationId: string;
  /** '' for the Overview route, '/files' for the Files route. */
  subPath: string;
};

/**
 * Detects whether the current location is a deal-scoped route
 * (`/deals/:implementationId` or `/deals/:implementationId/files`) and, if so,
 * returns the deal id + sub-page suffix. Used by the portal templates to swap
 * the flat portal nav for the deal-scoped sidebar. Returns null off deal routes.
 *
 * `useMatch` (not `useParams`) because the template renders outside the
 * `<Routes>` tree, where route params are not in scope.
 */
export function useDealRouteMatch(): DealRouteMatch | null {
  const overviewMatch = useMatch('/deals/:implementationId');
  const filesMatch = useMatch('/deals/:implementationId/files');
  const match = overviewMatch ?? filesMatch;
  const implementationId = match?.params.implementationId;
  if (!implementationId) return null;
  return { implementationId, subPath: filesMatch ? '/files' : '' };
}
